export enum CompanyNeedWorkerStatus {
	PREQUALIFIED = 'PREQUALIFIED',
	CONTACTED = 'CONTACTED',
	INTERVIEW = 'INTERVIEW',
	COMPANY_INTERVIEW = 'COMPANY_INTERVIEW',
	COMPANY_PROPOSED = 'COMPANY_PROPOSED',
	MISSION_PROPOSED = 'MISSION_PROPOSED',
	REJECTED = 'REJECTED',
}

export interface CompanyNeedWorker {
	workerId: string;
	lastname: string;
	firstname: string;
	workerPhone: string;
	workerEmail: string;
	picture?: string;
}

export interface WorkerToAdd {
	workerId: string;
	lastname: string;
	firstname: string;
	workerPhone: string;
	workerEmail: string;
	fromJobOffer?: boolean;
	picture?: string;
}

export interface AddWorkersToCompanyNeed {
	workers: WorkerToAdd[];
	status: CompanyNeedWorkerStatus;
}

export interface UpdateCompanyNeedWorkerStatus {
	status: CompanyNeedWorkerStatus;
}

export interface WorkerAlreadyExists {
	id: string;
	workerId: string;
	lastname: string;
	firstname: string;
}

export interface AddWorkersToCompanyNeedResponse {
	besoinId: string;
	created: number;
	workerIds: string[];
	alreadyExists: WorkerAlreadyExists[];
}

export interface UpdateCompanyNeedWorkerStatusResponse {
	besoinId: string;
	workerId: string;
	previousStatus: CompanyNeedWorkerStatus;
	newStatus: CompanyNeedWorkerStatus;
}
